import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { getContext, initDataDogRum } from '@paypalcorp/cms-engine/client';
import type { AppProps } from '@paypalcorp/cms-engine';
import App from './App';

initDataDogRum();

const { renderContext } = getContext(window);

hydrateRoot(
  document.getElementById('root') as HTMLElement,
  <App
    renderContext={renderContext as AppProps}
  />,
);
